var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center dailies-header"},[_c('SelectStore',{staticClass:"q-mx-sm",attrs:{"storeCode":_vm.storeCode,"floorCode":_vm.floorCode,"inverted":""},on:{"change":_vm.onChangeStore}}),_c('SelectPeriod',{staticClass:"q-mx-sm",attrs:{"value":_vm.beginDate,"buttons":"","inverted":""},on:{"change":_vm.onChangeDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }